import { atomWithStorage } from 'jotai/utils';

export type VoicePreferences = {
  languageCode: string;
  voice: string;
  style: string;
  speed: number;
  // Opt-in wake-word ("Hello Opal") activation. When off, voice mode
  // only starts on the explicit mic button — when on, the detector
  // keeps the mic open continuously waiting for the wake phrase.
  wakeWordEnabled: boolean;
};

export const DEFAULT_VOICE_PREFERENCES: VoicePreferences = {
  languageCode: 'en-US',
  voice: 'en-US-Chirp3-HD-Aoede',
  style: 'friendly',
  speed: 1.0,
  wakeWordEnabled: false,
};

/**
 * Mirrors the tts_* columns on user_preferences.
 *
 * Backed by localStorage (matches the fontSizeAtom pattern) so the UI
 * has correct values on first paint without waiting on a network call.
 * `useUserPreferences` runs at app load and overwrites with the
 * server-authoritative value, so cross-device sync still works — local
 * storage just removes the flash of defaults on refresh.
 */
export const voicePreferencesAtom = atomWithStorage<VoicePreferences>(
  'opal-voice-preferences',
  DEFAULT_VOICE_PREFERENCES
);
